import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import Select, { components } from "react-select";
import ReactTooltip from "react-tooltip";
import { FiInfo } from "react-icons/fi";
import { userloginDetails } from "../Utils/AdminAuth";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
import Axios from "../../axios/Axios";

const YearlyAgentPlan = () => {
    const { id } = useParams();
    const history = useHistory();
    const lStorage = userloginDetails();

    const userId = lStorage?.user?.userId;
    const token = lStorage?.token;

    const [formData, setFormData] = useState({
        country: [],
        currency: "INR",
        discount: ""
    });

    const [countryOptions, setCountryOptions] = useState([{ value: "ALL", label: "All" }]);
    const [successMessage, setSuccessMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [bgColor, setBgColor] = useState("");
    const [isEdit, setIsEdit] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCountryChange = (selectedOptions) => {
        if (!selectedOptions) {
            setFormData({ ...formData, country: [] });
            return;
        }

        const allCountries = countryOptions.filter(c => c.value !== "ALL");
        const isAllClicked = selectedOptions.some(c => c.value === "ALL");

        if (isAllClicked) {
            const allCurrentlySelected = formData.country.length === allCountries.length;
            setFormData({
                ...formData,
                country: allCurrentlySelected ? [] : allCountries,
            });
        } else {
            setFormData({ ...formData, country: selectedOptions });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                user_id: userId,
                token,
                method: id ? "yearly_discount_update" : "yearly_discount_create",
                country:
                    formData.country.length === countryOptions.filter(c => c.value !== "ALL").length
                        ? ["ALL"]
                        : formData.country.map(c => c.value),
                currency: formData.currency,
                discount: Number(formData.discount)
            };

            if (id) {
                payload.id = id;
            }

            const response = await Axios.post(
                `${NODE_HOST_URL}/admin/plans`,
                payload
            );

            const result = response.data;

            if (result.success) {
                setBgColor("alert alert-success alert-dismissible");
                setErrorMessage(result.message);
                setTimeout(() => {
                    history.push("/admin/yearly-plan-settings");
                }, 1000);
            } else {
                setBgColor("alert alert-danger alert-dismissible");
                setErrorMessage(result.message);
            }

            setSuccessMessage(true);
        } catch (error) {
            setBgColor("alert alert-danger alert-dismissible");
            setErrorMessage(error?.response?.data?.message || "Something went wrong!");
            setSuccessMessage(true);
        }
    };

    const normalizeCountry = (apiCountry) => {
        if (!apiCountry) return "";

        return apiCountry
            .toLowerCase()
            .replace("(the)", "")
            .trim()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const fetchPlanDetail = async (id) => {
        try {
            const payload = {
                user_id: userId,
                token,
                method: "yearly_discount_retrieve",
                id
            };

            const response = await Axios.post(`${NODE_HOST_URL}/admin/plans`, payload);
            const result = response.data;

            if (result.success && Array.isArray(result.data)) {
                const data = result.data.find(item => item._id === id);

                if (data) {
                    setFormData({
                        currency: data.currency || "INR",
                        country: Array.isArray(data.country)
                            ? data.country.map(c => ({
                                value: normalizeCountry(c),
                                label: normalizeCountry(c)
                            }))
                            : [{
                                value: normalizeCountry(data.country),
                                label: normalizeCountry(data.country)
                            }],
                        discount: data.discount || ""
                    });

                }
            }
        } catch {
            setSuccessMessage(true);
            setBgColor("alert alert-danger alert-dismissible");
            setErrorMessage("Something went wrong!");
        }
    };


    useEffect(() => {
        fetch(`${HOST_URL}/country_master.php`)
            .then((res) => res.json())
            .then((result) => {
                if (result.success === true) {
                    setCountryOptions([
                        { value: "ALL", label: "All" },
                        ...result.data.map((c) => ({
                            label: c.country_name,
                            value: c.country_name,
                        })),
                    ]);
                }
            });
    }, []);

    useEffect(() => {
        if (id) {
            fetchPlanDetail(id);
        }
    }, [id]);

    const InfoLabel = ({ text, info, id, required }) => (
        <label className="form-label d-flex align-items-center gap-2">
            {text}

            {required && <span className="text-danger">*</span>}

            <FiInfo
                size={12}
                className="text-muted"
                data-tip
                data-for={id}
                data-event="click"
                style={{ cursor: "pointer" }}
            />

            <ReactTooltip
                id={id}
                place="right"
                effect="solid"
                globalEventOff="click"
                clickable
            >
                {info}
            </ReactTooltip>
        </label>
    );

    const Option = (props) => {
        const { data, isSelected, selectProps } = props;
        const allCountries = selectProps.options.filter(o => o.value !== "ALL");
        const isAllSelected = selectProps.value?.length === allCountries.length;
        const checked = data.value === "ALL" ? isAllSelected : isSelected;

        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => null}
                    style={{ marginRight: 8 }}
                />
                {data.label}
            </components.Option>
        );
    };

    const MultiValue = (props) => {
        const { index, getValue } = props;
        const selected = getValue();
        const allCountries = countryOptions.filter(c => c.value !== "ALL");
        const isAllSelected = selected.length === allCountries.length && allCountries.length > 0;

        if (isAllSelected) {
            return index === 0 ? (
                <div style={{ margin: "2px 6px", fontSize: 12, color: "#333" }}>All Countries</div>
            ) : null;
        }

        const maxToShow = 3;
        if (index < maxToShow) return <components.MultiValue {...props} />;
        if (index === maxToShow) return (
            <div style={{ marginLeft: 6, fontSize: 12, color: "#666" }}>+{selected.length - maxToShow} more</div>
        );
        return null;
    };

    return (
        <div className="wrapper">
            <AdminLeftMenu />

            <div className="main">
                <AdminHeader />

                <main className="content">
                    <div className="container-fluid p-0">

                        <div className="row mb-2 mb-xl-3">
                            <div className="col-auto d-none d-sm-block">
                                <h3>
                                    <strong>Yearly Plan Settings</strong>
                                </h3>
                            </div>
                        </div>

                        {successMessage && (
                            <div className={bgColor} role="alert">
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="alert"
                                >
                                    <span>×</span>
                                </button>
                                <div>{errorMessage}</div>
                            </div>
                        )}

                        <div className="card p-4">
                            <form onSubmit={handleSubmit}>

                                {/* FIRST ROW – FIELDS */}
                                <div className="row">

                                    {/* Country */}
                                    <div className="col-md-4 mb-3">
                                        <InfoLabel
                                            text="Country"
                                            info="Country where the yearly discount will be applied."
                                            id="yearlyCountryInfo"
                                        />

                                        <Select
                                            options={countryOptions}
                                            isMulti
                                            value={formData.country}
                                            onChange={handleCountryChange}
                                            placeholder="Select Countries"
                                            components={{ Option, MultiValue }}
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={false}
                                            maxMenuHeight={200}
                                        />
                                    </div>

                                    {/* Currency */}
                                    <div className="col-md-4 mb-3">
                                        <InfoLabel
                                            text="Currency"
                                            info="Currency used for billing in this country."
                                            id="yearlyCurrencyInfo"
                                        />

                                        <select
                                            name="currency"
                                            className="form-control"
                                            value={formData.currency}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="INR">INR</option>
                                            <option value="USD">USD</option>
                                            <option value="EUR">EUR</option>
                                        </select>
                                    </div>

                                    {/* Discount */}
                                    <div className="col-md-4 mb-3">
                                        <InfoLabel
                                            text="Discount (%)"
                                            info="Percentage discount applied when a yearly plan is selected."
                                            id="yearlyDiscountInfo"
                                        />

                                        <input
                                            type="number"
                                            name="discount"
                                            className="form-control"
                                            value={formData.discount}
                                            onChange={handleChange}
                                            min="0"
                                            max="100"
                                            placeholder="Discount %"
                                            required
                                        />
                                    </div>

                                </div>

                                {/* SECOND ROW – BUTTON */}
                                <div className="row">
                                    <div className="col-12 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-primary">
                                            {id ? "Update" : "Create"}
                                        </button>

                                    </div>
                                </div>

                            </form>
                        </div>


                    </div>
                </main>

                <AdminFooter />
            </div>
        </div>
    );
};

export default YearlyAgentPlan;
